const statuses = ["Ready", "Attention", "Blocked", "Running", "Draft", "Confirmed"];

export function DesignSystemPage() {
  return (
    <div className="page-stack design-system-page">
      <section className="surface-card design-system-intro">
        <span className="section-kicker">FOUNDATION</span>
        <h2>Design System Playground</h2>
        <p>
          Ta route jest miejscem akceptacji wspólnych komponentów zanim trafią do Generatora,
          Transportu i Manual Board. Nie budujemy kolejnych ekranów z własnymi kontrolkami.
        </p>
      </section>

      <section className="surface-card design-system-section">
        <div className="section-head"><div><span className="section-kicker">ACTIONS</span><h3>Przyciski</h3></div></div>
        <div className="component-row">
          <button className="primary-button" type="button">Primary action</button>
          <button className="secondary-button" type="button">Secondary</button>
          <button className="text-button" type="button">Text action</button>
          <button className="icon-button" type="button" aria-label="Przykładowa akcja">⌕</button>
        </div>
      </section>

      <section className="surface-card design-system-section">
        <div className="section-head"><div><span className="section-kicker">STATUS</span><h3>Stany operacyjne</h3></div></div>
        <div className="component-row">
          {statuses.map((status) => <span className="ds-status" data-state={status.toLowerCase()} key={status}>{status}</span>)}
        </div>
      </section>

      <section className="surface-card design-system-section">
        <div className="section-head"><div><span className="section-kicker">TRANSPORT</span><h3>Tożsamość auta</h3></div></div>
        <div className="transport-token-grid">
          {["Vivaro 16586", "Vivaro 16590", "Vivaro 17618", "Vivaro 17619", "Trafic 13744", "Vehicle 6"].map((vehicle, index) => (
            <div className={`vehicle-token vehicle-token-${index + 1}`} key={vehicle}>
              <strong>{vehicle}</strong><span>ten sam token w UI, Manual Board i eksporcie</span>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
